module.exports = __webpack_public_path__ + "img/bmsHome-sm.eeaf9011.jpg";